import { render, staticRenderFns } from "./galeriListesi.vue?vue&type=template&id=0ad453fc&scoped=true&"
import script from "./galeriListesi.vue?vue&type=script&lang=js&"
export * from "./galeriListesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad453fc",
  null
  
)

export default component.exports